<template>
  <div>
    <footer class="footer">
      <div class="content has-text-centered is-white">
        <p><strong> Vue Windbnb</strong> by <a href="">John Njau</a>.</p>
      </div>

    </footer>
  </div>
</template>
<script>
export default {}
</script>

<style scoped>
</style>
